import {
  PageContainer,
  SecondaryContainer as CommonContainer,
  TabRenderer,
  TabContentRenderer,
} from "components";
import { useEffect } from "react";
import { useRouter } from "next/router";
import styled from "styled-components";
import { replaceIfNotExist } from "utils/newFunction";

function Tab({
  data,
  className,
  onTabChange,
  activeTab,
  metaTag,
  changeLanguageLink,
  breadcrumb,
}) {
  const router = useRouter();

  const handleTabChange = (tab) => {
    // setActiveTab(slug);
    onTabChange?.(tab?.slug);
  };

  useEffect(() => {
    if (data?.tabs.length > 0 && !activeTab) {
      onTabChange?.(activeTab?.slug);
    }
  }, [data?.tabs, router.query]);

  return (
    <PageContainer
      useDefaultHrefLang={data?.useDefaultHrefLang}
      breadCrumb={breadcrumb || data?.breadcrumb}
      metaTag={
        metaTag ||
        replaceIfNotExist(activeTab?.seo, {
          title: activeTab?.title || "",
        })
      }
      changeLanguageLink={activeTab?.changeLanguageLink || changeLanguageLink}
      noIndex={activeTab?.noIndex || data?.noIndex}
    >
      <div className="tw-pb-[50px]">
        <div className="tw-border-solid tw-border-x-0 tw-border-t-0 tw-border-b-[#344456]/5">
          <CommonContainer>
            <div className="tw-px-4 md:tw-px-0">
              <TabRenderer
                tabs={data?.tabs}
                activeTab={activeTab}
                onTabChange={handleTabChange}
              />
            </div>
          </CommonContainer>
        </div>
        <CommonContainer>
          <TabContentRenderer
            tabs={data?.tabs}
            activeTab={activeTab}
            className={className}
          />
        </CommonContainer>
      </div>
    </PageContainer>
  );
}

const StyledTab = styled(Tab)`
  .border-item:last-of-type {
    display: none;
  }
`;
export default StyledTab;
